import { createReducer, on } from '@ngrx/store';
import {
  showLoader,
  hideLoader,
  loadProductsSuccess,
  loadCategoriesSuccess,
  loadOccasionsSuccess,
  resetProducts,
  setFilters,
 
} from './product.action';

import { ProductsState, ProductFilters } from './product.model';
import { Product } from '../../app/shared/interface/home';

export const initialState: ProductsState = {
  products: [],
  originalProducts: [],
  categories: [],
  occasions: [],
  loader: false,
   
  filters: {
    keyword: '',
    minPrice: null,
    maxPrice: null,
    minRate: undefined,
    categories: [],
    occasions: []
  }
};


function applyFilters(products: Product[], filters: ProductFilters): Product[] {
  const keyword = filters.keyword.toLowerCase();

  return products.filter(p => {
    const productRate = p.rateAvg ?? 0;

    return (
     
      (filters.minPrice === null || p.price >= filters.minPrice) &&
      (filters.maxPrice === null || p.price <= filters.maxPrice) &&

      (filters.minRate === undefined || productRate <= filters.minRate) &&

      
      (filters.categories.length === 0 || filters.categories.includes(p.category)) &&

      
      (filters.occasions.length === 0 || filters.occasions.includes(p.occasion)) &&

      
      (keyword === '' ||
        p.title.toLowerCase().includes(keyword) ||
        p.description.toLowerCase().includes(keyword))
    );
  });
}


export const productsReducer = createReducer(
  initialState,

  on(showLoader, state => ({ ...state, loader: true })),
  on(hideLoader, state => ({ ...state, loader: false })),

  on(loadProductsSuccess, (state, { products }) => ({
    ...state,
    originalProducts: products,
    products,
    loader: false
  })),

  on(loadCategoriesSuccess, (state, { categories }) => ({
    ...state,
    categories: categories.filter(c =>
      state.originalProducts.some(p => p.category === c._id)
    )
  })),

  on(loadOccasionsSuccess, (state, { occasions }) => ({
    ...state,
    occasions: occasions.filter(o =>
      state.originalProducts.some(p => p.occasion === o._id)
    )
  })),

  on(setFilters, (state, filters) => {
    const newFilters: ProductFilters = {
      keyword: filters.keyword ?? state.filters.keyword,
      minPrice: filters.minPrice ?? state.filters.minPrice,
      maxPrice: filters.maxPrice ?? state.filters.maxPrice,
      minRate: filters.minRate ?? undefined,
      categories: filters.categories ?? state.filters.categories,
      occasions: filters.occasions ?? state.filters.occasions
    };

    return {
      ...state,
      filters: newFilters,
      products: applyFilters(state.originalProducts, newFilters)
    };
  }),

  on(resetProducts, state => ({
    ...state,
    filters: {
      keyword: '',
      minPrice: null,
      maxPrice: null,
      minRate: undefined,
      categories: [],
      occasions: []
    },
    products: [...state.originalProducts]
  })),

);
